<div class="panel panel-primary">
    <div class="panel-heading">
        {{pageTitle}}
    </div>
    <div class="panel-body">
        <div class="row">
            <!--<img src="./app/assets/images/logo.jpg" 
                 class="img-responsive center-block"
                 style="max-height:300px;padding-bottom:50px"/>-->
        </div>
        <div class="row">
            <div class="text-center">Developed by:</div>
            <h3 class="text-center">Devon Albert</h3>
        </div>
    </div>
</div>